export default {
  label: {
    today: '今天',
    yesterday: '昨天',
    toMonth: '当月',
    todayDetails: '今日详情',
    yesterdayDetails: '昨日详情',
    toMonthDetails: '当月详情',
    focusinfo: '焦点资讯',
    amountOfFail: '交易失败金额',
    amountOfProfit: '收益',
    amountOfSuccess: '交易成功金额',
    amountOfTotal: '交易总金额',
    paymentNumberOfSuccess: '代收成功单数',
    payoutNumberOfSuccess: '代付成功单数',
    paymentNumberOfFail: '代收失败单数',
    payOutNumberOfFail: '代付失败单数',
    paymentNumberOfTotal: '代收总单数',
    payoutNumberOfTotal: '代付总单数',
    paymentAmountOfSuccess: '代收成功金额',
    payoutAmountOfSuccess: '代付成功金额',
    paymentAmountOfFail: '代收失败金额',
    payoutAmountOfFail: '代付失败金额',
    paymentAmountOfTotal: '代收总金额',
    payoutAmountOfTotal: '支付总额',
    channel: '支付通道',
    dateByDay: '日期',
    dateByMonth: '月份',
    dateType: '时间类型',
    id: 'ID',
    numberOfFail: '交易失败笔数',
    numberOfSuccess: '交易成功笔数',
    numberOfTotal: '交易总笔数',
    owner: '拥有者',
    updateTime: '更新时间',
    userType: '用户类型',
    successRate: '成功率',
    MerchantBalance: '商户余额',
    totalWalletBalance: '钱包总余额',
    usdtWalletBalance: 'USDT余额'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/welcome.js